import { render, staticRenderFns } from "./recucler-list.vue?vue&type=template&id=45ed2514&scoped=true&"
import script from "./recucler-list.vue?vue&type=script&lang=ts&"
export * from "./recucler-list.vue?vue&type=script&lang=ts&"
import style0 from "./recucler-list.vue?vue&type=style&index=0&id=45ed2514&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ed2514",
  null
  
)

export default component.exports